/** Auto-generated by scripts/sync-dev-build-meta.js — do not edit manually */
export const devGitBranch = 'feature/1642-native-push-notifications';
export const devGitShortSha = 'd4e3f22e0';
export const devGitWorktreeTag = 'wt-66ba2dc';
